import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  id: "Alone"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_MvList = _resolveComponent("MvList");

  var _component_Loading = _resolveComponent("Loading");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 独家放送列表 "), _ctx.aloneList.length > 5 ? (_openBlock(), _createBlock(_component_MvList, {
    key: 0,
    mvList: _ctx.aloneList,
    isUnderLine: true
  }, null, 8
  /* PROPS */
  , ["mvList"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 加载组件 "), _createVNode(_component_Loading)], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  ))]);
}